import callApi from "helpers/callApi";

export const CLIENT_PAYMENT_CREATE_ENDPOINT = (fundRequestId) =>
  `/manager/billing_history/fund_request/${fundRequestId}/client_payments`;

export const CLIENT_PAYMENT_VOID_ENDPOINT = (fundRequestId, clientPaymentId) =>
  `/manager/billing_history/fund_request/${fundRequestId}/client_payments/${clientPaymentId}/void`;

function parseClientPaymentApiError(response) {
  throw new Error(response.errorMessage || "Error");
}

export async function createClientPayment(fundRequestId, formData) {
  const response = await callApi(
    CLIENT_PAYMENT_CREATE_ENDPOINT(fundRequestId),
    "POST",
    formData,
    { contentType: "multipart/form-data" },
  );
  if (!response.ok) {
    parseClientPaymentApiError(response);
  }
  return response.json();
}

export async function voidClientPayment(fundRequestId, clientPaymentId, reason) {
  const response = await callApi(
    CLIENT_PAYMENT_VOID_ENDPOINT(fundRequestId, clientPaymentId),
    "POST",
    { reason },
  );
  if (!response.ok) {
    parseClientPaymentApiError(response);
  }
  return response.json();
}
